<div class="dialogue-content">
  <div class="mat-dialogue-header border-0 pb-0">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title"></h4>
    <button type="button" class="btn-close" aria-label="Close" [mat-dialog-close]="false"></button>
  </div>
  <mat-dialog-content class="pt-0">
    <div class="d-flex align-items-center justify-content-center gap-2 flex-column">
      <img src="../../../assets/img/login-logo.svg" alt="" class="logo" />
      <p class="title_approve">Are you sure you want to add event?</p>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions class="dialog-actions dialogue-footer text-center mb-3">
    <button class="btn btn-primary" [mat-dialog-close]="true">Yes</button>
  </div>
</div>